<div class="page-header-container">
    <div class="page-title">
        <button class="btn link-btn btn-back">
            <i class="app-icon icon icon-chevron-left icon-xxl" (click)="redirectRequestTypeHandler()"></i>
        </button>
        {{'requests.cards.title' | translate}}
    </div>
</div>

<div class="header-buttons-box">
    <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()">
        {{'request.filter' | translate}}
    </button>
    
    <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
        <div class="btn-group" role="group">
            <button class="btn white-btn text-uppercase" (click)="filterHandler()">
                <span>{{'request.filterActive' | translate}}</span>
            </button>
            <button class="btn white-btn" (click)="resetFiltersHandler()">
                <span class="active-filters-badge">{{activeFilterCount}}</span>
                <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
            </button>
        </div>
    </div>

    <div [ngbTooltip]="bypassRestrictionsAssetDocumentRequest? null : warningMessages.length > 0 ? warningMessagesTemplate : (noActiveContracts ? noActiveContractsTemplate : null)" 
        tooltipClass="request-warning-tooltip opacity-100" 
        placement="bottom-end">
        <button class="btn primary-btn" 
            (click)="redirectNewRequest()" 
            [hidden]="readOnly" 
            [disabled]="!bypassRestrictionsAssetDocumentRequest && (warningMessages.length > 0 || noActiveContracts)">
            {{'requests.cards.addNewRequest' | translate}}
        </button>
    </div>
</div>

<div *ngIf="!hasData && !isFiltered" class="d-flex flex-column align-items-center">
    <h3 class="text-center text-secondary my-4">{{'requests.cards.noRecords' | translate}}</h3>
    <no-records-placeholder></no-records-placeholder>
</div>

<div *ngIf="!hasFilterData && isFiltered" class="d-flex flex-column align-items-center my-5 my-lg-0">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()"
    ></no-records-placeholder>
</div>

<requests-card-view *ngIf="hasData && hasFilterData"
    [requests]="requests" 
    [props]="requestsProps" 
    (downloadPolicy)="downloadPolicy($event)"
    [viewDetails]="viewDetailsHandler"
></requests-card-view>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>

<ng-template #warningMessagesTemplate>
    <ul class="text-start py-2 ps-4 m-0 d-flex flex-column gap-3">
        <li *ngFor="let message of warningMessages" [innerHtml]="message | translate"></li>
    </ul>
</ng-template>

<ng-template #noActiveContractsTemplate>
    {{ "requests.cards.disabledAddNewRequestToolTip" | translate }}
</ng-template>
